/**
 * Mandatory Diplomexa brand attribution.
 *
 * Per brand policy: every public page, every signed-in dashboard, every
 * certificate verifier, every email/PDF must show one of:
 *   - "Powered by Diplomexa"
 *   - "Powered by Diplomexa by Destineze and Factskoot"  ← canonical
 *   - "Diplomexa — by Destineze and Factskoot"
 *
 * This component is the canonical implementation. Reuse it instead of
 * inlining the string so a future brand-line update is a one-file change.
 *
 * Props:
 *   - `tone`: "light" (default, for white/light backgrounds) or "dark"
 *             (for navy/dark hero sections)
 *   - `className`: spacing / typography override
 *   - `align`: "left" | "center" | "right" (default: "center")
 */
export default function BrandAttribution({ tone = "light", className = "", align = "center" }) {
  const muted = tone === "dark" ? "text-slate-400" : "text-slate-500";
  const link = tone === "dark"
    ? "text-slate-200 hover:text-white"
    : "text-slate-700 hover:text-[#0F4C81]";
  const alignCls = { left: "text-left", center: "text-center", right: "text-right" }[align];
  return (
    <p
      data-testid="brand-attribution"
      className={`text-[11px] ${muted} ${alignCls} ${className}`}
    >
      Powered by Diplomexa by{" "}
      <a
        href="https://www.destineze.com"
        target="_blank"
        rel="noreferrer"
        className={`${link} underline-offset-2 hover:underline`}
      >
        Destineze
      </a>{" "}
      and{" "}
      <a
        href="https://www.factskoot.com"
        target="_blank"
        rel="noreferrer"
        className={`${link} underline-offset-2 hover:underline`}
      >
        Factskoot
      </a>
    </p>
  );
}
